import React from "react"
import {Accordion, AccordionSummary, Grid, Typography} from "@material-ui/core"

import eSignConsentGrantedIcon from "./icons/eSignConsentGranted.svg"

import {CustomerDigitalCommunicationConsentActivityPayload} from "@indebted/api"

function ESIGNConsentGrantedActivity(
	panelId: number,
	{
		Title,
		HappenedAt,
	}: {Title: string; HappenedAt: string; Payload: CustomerDigitalCommunicationConsentActivityPayload},
	expanded: boolean,
	classes: {summary: string},
) {
	return (
		<Accordion expanded={expanded}>
			<AccordionSummary>
				<Grid style={{padding: "0 2px"}}>
					<img src={eSignConsentGrantedIcon} width={20} />
				</Grid>
				<Typography className={classes.summary}>
					{" "}
					<b>{Title}</b> - {HappenedAt}
				</Typography>
			</AccordionSummary>
		</Accordion>
	)
}

export {ESIGNConsentGrantedActivity}
